import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { IrisFilesService } from '@iris/common/modules/dms/services/files.service';
import { UserAvatarComponent } from '@ngx-strakit/cdk/controls';

@Component({
  selector: 'iris-header-search-result-for-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    UserAvatarComponent,
  ],
})
export class IrisHeaderSearchResultForUserComponent {
  filesService = inject(IrisFilesService);

  userInfo = input<IdentUserI>();
  avatarUrl = computed(() => {
    return this.userInfo()?.avatarFileId ? this.filesService.getFileContentUrl(this.userInfo().avatarFileId) : null;
  });
}
